import { createAsyncThunk } from '@reduxjs/toolkit';

import { SectionNameEnum, SliceNameEnum } from '@app/enums';
import { CmsHomepageService } from '@app/services/cms-homepage.service';

const sectionFetcherMap: Partial<
    Record<SectionNameEnum, (preview: boolean, documentId?: string) => Promise<any>>
> = {
    [SectionNameEnum.HeroSection]: (preview, documentId) =>
        CmsHomepageService.instance.getHeroSection(preview, documentId),
    [SectionNameEnum.DestinationSuggestionsSection]: (preview, documentId) =>
        CmsHomepageService.instance.getDestinationSuggestions(preview, documentId),
    // [SectionNameEnum.FeaturedAccommodationsSection]: (preview, documentId) =>
    //     CmsHomepageService.instance.getFeaturedAccommodations(preview, documentId),
};

export const getCmsSectionData = createAsyncThunk(
    `${SliceNameEnum.CmsHomepage}/getCmsSectionData`,
    async ({
        section,
        preview = false,
        documentId,
    }: {
        section: SectionNameEnum;
        preview?: boolean;
        documentId?: string;
    }) => {
        const fetcher = sectionFetcherMap[section];

        if (!fetcher) {
            throw new Error(`Unsupported CMS section: ${section}`);
        }

        const data = await fetcher(preview, documentId);
        return { section, data };
    },
);
